import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App'
import { escucharSistema } from './store/themeStore'
import './index.css'

// Aplica la clase `.dark` ANTES del primer render (misma clave que persiste `themeStore.js`) para
// que no haya un parpadeo claro→oscuro al cargar con el modo oscuro ya elegido.
;(function initTheme() {
  try {
    const raw = localStorage.getItem('coredesk-partner-theme')
    const savedTheme = raw ? JSON.parse(raw)?.state?.theme : null
    const prefiereOscuro = window.matchMedia?.('(prefers-color-scheme: dark)').matches
    const isDark = savedTheme === 'dark' || (savedTheme !== 'light' && prefiereOscuro)
    document.documentElement.classList.toggle('dark', !!isDark)
  } catch {
    // localStorage inaccesible (modo privado estricto, etc.) — se queda en claro.
  }
})()

// Con la preferencia «Sistema», el portal cambia de tema cuando cambia el del teléfono o la PC.
escucharSistema()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          // Sigue al tema (antes era #333 fijo, un bloque negro también en modo claro).
          style: {
            background: 'hsl(var(--card))',
            color: 'hsl(var(--card-foreground))',
            border: '1px solid hsl(var(--border))',
            boxShadow: '0 12px 32px -8px rgba(15,30,72,0.25)',
            fontSize: '14px',
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>,
)
